
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        size: {
            type: String as PropType<'small' | 'medium' | 'big'>,
            default: 'medium'
        },
        color: {
            type: String as PropType<'royal-blue'>,
            default: 'royal-blue'
        },
        modelValue: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['update:modelValue', 'change'],
    setup(props, { emit }) {
        const onToggle = () => {
            if (props.disabled) return
            emit('update:modelValue', !props.modelValue)
            emit('change', !props.modelValue)
        }

        return {
            onToggle
        }
    }
})
